/* eslint-disable react-hooks/exhaustive-deps */
import {
  ChevronDown,
  ChevronUp,
  AlertCircle,
  RotateCcw,
  Download,
  Edit,
  Trash2,
  Check,
  X,
  Plus
} from 'lucide-react'
import { Formik } from 'formik'
import { useEffect, useState } from 'react'
import {
  Badge,
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
  Table
} from 'react-bootstrap'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import Select from 'react-select'
import Swal from 'sweetalert2'
import {
  BadgeStatusCOA,
  BadgeStatusPrLists
} from '../../../components/atoms/StatusLabel/index'
import Breadcrumb from '../../../components/Label/Breadcrumb'
import ModalPrDetailTimeline from '../../../components/modal/pr/ModalPrDetailTimeline'
import ModalUpdateItemCoaPrDraftDetail from '../../../components/modal/pr/ModalUpdateItemCoaPrDraftDetail'
import ModalUpdateVehiclePrDraft from '../../../components/modal/pr/ModalUpdateVehiclePrDraft'
import ModalAddItemPr from '../../../components/modal/pr/ModalAddItemPr'
import api from '../../../config/AxiosInstance'
import {
  convertDateWithoutTime,
  convertDateWithTime,
  transformKey
} from '../../../helpers/constants'
import '../../../styles/style.css'
import * as Common from '../../../utils/Common'
import { PurchaseReceiptCreateImportSchema } from '../../../utils/validationSchema'
import TableItemReceiptDetails from './tableItem'
import Loading from '../../../components/atoms/Loading'

const cardStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const labelDetailStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#999',
  textTransform: 'uppercase',
  marginBottom: '0.25rem',
  letterSpacing: '0.5px'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const StyledTextField = ({
  label,
  value,
  name,
  handleChange,
  handleBlur,
  touched,
  errors,
  type = 'text',
  placeholder,
  required,
  disabled,
  as,
  col = 12
}) => {
  return (
    <Form.Group className={`mb-3 col-12 col-md-${col}`}>
      <Form.Label style={labelDetailStyle}>
        {label} {required && <sup className="text-danger">*</sup>}
      </Form.Label>
      <Form.Control
        as={as}
        type={type}
        name={name}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        isInvalid={touched?.[name] && !!errors?.[name]}
        placeholder={placeholder}
        disabled={disabled}
        className={`px-3`}
        style={{
          fontSize: '0.9rem',
          height: as === 'textarea' ? 'auto' : '40px',
          borderRadius: '8px',
          border: '1px solid #ced4da',
          backgroundColor: disabled ? '#e9ecef' : '#fff',
          cursor: disabled ? 'not-allowed' : 'default'
        }}
        autoComplete="off"
      />
      <Form.Control.Feedback type="invalid">
        {errors?.[name]}
      </Form.Control.Feedback>
    </Form.Group>
  )
}

const StyledDetailField = ({ label, value, col = 12, address = null }) => {
  return (
    <Form.Group className={`mb-3 col-12 col-md-${col}`}>
      <Form.Label style={labelDetailStyle}>{label}</Form.Label>
      {address ? (
        <div
          dangerouslySetInnerHTML={{
            __html: value
          }}
          className="px-3 py-2 bg-white rounded border"
          style={{
            fontSize: '0.9rem',
            minHeight: '40px',
            borderColor: '#ced4da'
          }}
        />
      ) : (
        <Form.Control
          type="text"
          value={value || '-'}
          readOnly
          className="px-3 bg-light"
          style={{
            fontSize: '0.9rem',
            height: '40px',
            borderRadius: '8px',
            border: '1px solid #ced4da',
            cursor: 'not-allowed'
          }}
        />
      )}
    </Form.Group>
  )
}

function PurchaseReceiptDetail() {
  const navigate = useNavigate()
  const { state } = useLocation()
  const [isLoading, setIsLoading] = useState(false)
  const [open, setOpen] = useState(true)
  const [openVehicle, setOpenVehicle] = useState(true)
  const [openItemCoa, setOpenItemCoa] = useState(true)
  const [loadingPrTimeline, setLoadingPrTimeline] = useState(false)
  const [modalUpdateShow, setModalUpdateShow] = useState(false)
  const [modalTimeline, setModalTimeline] = useState(false)
  const [selectedVehicle, setSelectedVehicle] = useState(0)
  const [loadingSendToErp, setLoadingSendToErp] = useState(false)
  const [detail, setDetail] = useState({})
  const [mapVehicles, setMapVehicles] = useState([])
  const [differentDate, setDifferentDate] = useState()
  const [detailInbounds, setDetailInbounds] = useState({})
  const [assignAreaId, setAssignAreaId] = useState([])
  const [areaData, setAreaData] = useState([])
  const [loadingArea, setLoadingArea] = useState(false)
  const [modalUpdateItemCoa, setModalUpdateItemCoa] = useState(false)
  const [selectedItemCoa, setSelectedItemCoa] = useState({})
  const [conditionItemInbound, setConditionItemInbound] = useState({
    inputValue: '',
    condition: ''
  })
  const [loadingDownloadPackingList, setLoadingDownloadGoodReceipt] =
    useState(false)
  const [downloadDocumentCoa, setDownloadDocumentCoa] = useState({})
  const { id } = useParams()
  const [dirtyPacks, setDirtyPacks] = useState({})
  const [items, setItems] = useState([])
  const [showModalAddItem, setShowModalAddItem] = useState(false)
  const isDraftDisabled =
    detail?.po_info?.draft_status === 'done' ||
    (detail?.inbounds?.length > 0 &&
      detail?.inbounds?.every((inbound) =>
        ['waiting_pnp', 'pnp', 'put_away', 'done'].includes(inbound.status)
      ))

  useEffect(() => {
    loadData(id)
  }, [id])

  useEffect(() => {
    loadItems()
  }, [detail?.po_info?.po_code])

  const loadItems = async () => {
    if (!detail?.po_info?.po_code) return
    try {
      const res = await api.get(
        `/inbound/pr-draft/show-items?po=${detail?.po_info?.po_code}`
      )
      const { data } = res.data
      setItems(data)
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    }
  }

  const onDeleteItemCoa = (item) => {
    Swal.fire({
      title: 'Are you sure delete?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      allowOutsideClick: false,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await api.delete(`inbound/pr-draft/${id}/coa/${item.id}`)
          if (res.data.success) {
            Common.showPopUpSuccessMessage(res.data.message)
            loadData(id)
          }
        } catch (err) {
          const errMsg =
            err?.response?.data?.errors?.message || 'An error occurred'
          Common.showPopUpErrorMessage(errMsg)
        }
      }
    })
  }

  useEffect(() => {
    if (conditionItemInbound?.condition) {
      loadFocusOptions(
        conditionItemInbound?.inputValue,
        conditionItemInbound?.condition
      )
    }
  }, [conditionItemInbound])

  const loadData = async (id) => {
    try {
      setIsLoading(true)
      let coaNotMatch = false
      const res = await api.get(`inbound/pr-draft/${id}`)
      const { data } = res.data
      setDetail(data)
      const dataVehicles = data.vehicles.map((data) => {
        return {
          ...data
        }
      })

      data.items_coa.forEach((data, i) => {
        const test = data.coa_ed === data.label_ed
        setDifferentDate(test)
      })
      if (
        data?.items_coa.filter(
          (item_coa) =>
            item_coa?.coa_status === 'not_match' ||
            item_coa?.coa_status === 'not match'
        )?.length > 0
      ) {
        coaNotMatch = true
      }
      setMapVehicles(dataVehicles)

      if (res.data.success) {
        const objTmpAssignArea = res.data.data.inbounds
          .reduce((acc, cur) => {
            let objParentAssignArea = null
            if (cur.status === 'waiting_om' || cur.status === 'request_pnp') {
              objParentAssignArea = {
                inbound_id: cur.id,
                areas:
                  cur.items.filter(
                    (item) => item.condition === 'damaged' && !item?.area_id
                  )?.length > 0 || coaNotMatch
                    ? []
                    : cur.items
                        .filter(
                          (x) =>
                            x.condition === 'good' ||
                            x.area === 'Area Gudang Karantina'
                        )
                        .reduce((accItem, curItem) => {
                          accItem.push({
                            item_staging_area_id: curItem.id,
                            area_id: curItem.area_id,
                            note: curItem.note || '',
                            is_rejected: [
                              'Area Gudang Utama',
                              'Area Gudang Karantina'
                            ].includes(curItem.area)
                              ? false
                              : true
                          })
                          return accItem
                        }, [])
              }
            }
            acc.push(objParentAssignArea)
            return acc
          }, [])
          .filter((x) => x !== null)
        if (objTmpAssignArea.length > 0) {
          setAssignAreaId(objTmpAssignArea)
        }
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setIsLoading(false)
    }
  }

  const handleSubmit = async () => {
    Swal.fire({
      title: 'Send to ERP?',
      text: `This action can't be repeated!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#f89d1d',
      confirmButtonText: 'Send'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await api.postForm(`/inbound/pr-draft/send-erp/${id}`)
          if (res.data.success) {
            Common.showPopUpSuccessMessage(res.data.message)
            navigate('/inbound/purchase-receipt')
          }
        } catch (err) {
          const errMsg =
            err?.response?.data?.errors?.message || 'An error occurred'
          Common.showPopUpErrorMessage(errMsg)
        }
      }
    })
  }

  const addVehicle = (values, resetForm) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'This will also create new inbound document. Proceed ? ',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#f89d1d',
      confirmButtonText: 'Yes, add it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const isPlateNoExists = mapVehicles.some(
            (vehicle) => vehicle.plate_no === values
          )
          if (isPlateNoExists) {
            Common.showPopUpErrorMessage('Plate No already in list')
            return
          }
          const body = {
            pr_id: id,
            plate_no: values.toUpperCase()
          }
          const newVehicleRes = await api.post('inbound/pr-draft/vehicle', body)
          const data = newVehicleRes.data.data
          setMapVehicles([...mapVehicles, data])
          resetForm({
            values: {
              plate_no: ''
            }
          })
          loadData(id)
        } catch (err) {
          const errMsg = err?.message || 'An error occurred'
          Common.showPopUpErrorMessage(errMsg)
        }
      }
    })
  }

  const [newDataVehicles, setNewDataVehicles] = useState([])

  useEffect(() => {
    setNewDataVehicles([...mapVehicles])
  }, [mapVehicles])

  function handleUpdateVehicle(item) {
    setModalUpdateShow(true)
    setSelectedVehicle(item)
  }

  const [dataHistory, setDataHistory] = useState({})

  const handleTimline = async (item) => {
    setModalTimeline(true)
    try {
      setLoadingPrTimeline(true)
      setDetailInbounds(item)
      const res = await api.get(`inbound/pr-draft/history/${item.id}`)
      const { status, data } = res
      if (status === 200) {
        setDataHistory(data)
      }
    } catch (err) {
      const errMsg = err?.data?.message || err?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoadingPrTimeline(false)
    }
  }

  function onDeleteItemVehicle(item) {
    Swal.fire({
      title: 'Are you sure delete?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      allowOutsideClick: false,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await api.delete(`inbound/pr-draft/vehicle/${item}`)
          if (res.data.success) {
            Common.showPopUpSuccessMessage(res.data.message)
            loadData(id)
          }
        } catch (err) {
          const errMsg = err?.message || 'An error occurred'
          Common.showPopUpErrorMessage(errMsg)
        }
      }
    })
  }

  const loadOptions = async (inputValue, condition) => {
    try {
      if (areaData.length > 0) {
        // first override to empty array
        setAreaData([])
      }
      setLoadingArea(true)
      const res = await api.get('/master/area/all', {
        params: {
          q: inputValue,
          id: detail?.po_info?.dest_warehouse_id,
          condition: condition === 'good' ? '' : condition
        }
      })
      if (res.data.success) {
        const options = res.data.data?.reduce(
          (acc, data) => {
            acc.unshift({
              value: data.id,
              label: `${data.name} ${
                data.has_slot ? '' : ` - Slot Unavailable!`
              }`,
              hasSlot: data.has_slot,
              code: data.code,
              is_reject: false
            })
            return acc
          },
          [{ value: null, label: 'TOLAK', hasSlot: false, is_reject: true }]
        )
        setAreaData(options)
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoadingArea(false)
    }
  }

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      fontSize: 14,
      color: !state.data.hasSlot ? '#C12727' : 'black',
      backgroundColor: 'transparent',
      fontWeight: !state.data.is_reject ? 'normal' : 'bold'
    })
  }

  const loadFocusOptions = (inputValue, condition) => {
    loadOptions(inputValue, condition)
  }

  const handleSelectAreaItemInbound = (inboundId, itemStagingId, data) => {
    setAssignAreaId((assignAreaPrev) =>
      assignAreaPrev.map((inbound) => {
        if (inbound.inbound_id === inboundId) {
          // Check if the areas array already contains the itemStagingId
          const areaExists = inbound.areas.some(
            (area) => area.item_staging_area_id === itemStagingId
          )
          if (areaExists) {
            // Update the area if it exists
            return {
              ...inbound,
              areas: inbound.areas.map((area) =>
                area.item_staging_area_id === itemStagingId
                  ? {
                      ...area,
                      area_id: data.value,
                      is_rejected: data.is_reject
                    }
                  : area
              )
            }
          } else {
            // Add a new area if it doesn't exist
            return {
              ...inbound,
              areas: [
                ...inbound.areas,
                {
                  item_staging_area_id: itemStagingId,
                  area_id: data.value,
                  is_rejected: data.is_reject,
                  note: null
                }
              ]
            }
          }
        }
        return inbound
      })
    )
  }

  const handleSubmitAndSendErp = (inboundId) => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary-orange',
        cancelButton: 'btn btn-transparent',
        actions:
          'd-flex w-100 justify-content-end pt-4 ps-4 pe-4 separator-border-action-sweetalert'
      },
      buttonsStyling: false
    })
    swalWithBootstrapButtons
      .fire({
        title: 'Send to ERP?',
        text: 'This action can’t be repeated!',
        icon: 'warning',
        iconColor: '#828282',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Send!',
        cancelButtonText: 'Cancel',
        allowOutsideClick: false,
        reverseButtons: true,
        showCloseButton: true
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          try {
            // read data value state assign area id
            if (!checkAssignArea(inboundId)) {
              Swal.close()
              Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Destination area is required'
              })
              return
            }
            setLoadingSendToErp(true)
            const res = await api.post(
              `inbound/pr-draft/assign-area/${inboundId}`,
              {
                areas: assignAreaId.find(
                  (inbound) => inbound.inbound_id === inboundId
                )?.areas
              }
            )
            if (res.data.success) {
              Swal.close()
              // override state value assign area id to empty array
              setAssignAreaId((prevAssignAreaId) =>
                prevAssignAreaId.filter(
                  (assignArea) => assignArea.inbound_id !== inboundId
                )
              )
              // load data
              loadData(id)
              Common.showPopUpSuccessMessage('Success')
            }
          } catch (err) {
            Swal.close()
            const errMsg =
              err?.response?.data?.errors?.message || 'An error occurred'
            const swalWithBootstrapButtonError = Swal.mixin({
              customClass: {
                confirmButton: 'btn btn-primary-orange',
                cancelButton: 'btn btn-transparent',
                actions:
                  'd-flex w-100 justify-content-end pt-4 ps-4 pe-4 separator-border-action-sweetalert'
              },
              buttonsStyling: false
            })
            swalWithBootstrapButtonError
              .fire({
                html: `<p>Send to ERP <span class='text-danger fw-bold text-uppercase'>failed</span></p><br><p>Reason: ${errMsg}</p>`,
                icon: 'error',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Resend',
                allowOutsideClick: false,
                showCloseButton: true
              })
              .then(async (result) => {
                if (result.isConfirmed) {
                  try {
                    if (!checkAssignArea(inboundId)) {
                      Swal.close()
                      Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Destination area is required'
                      })
                      return
                    }
                    const res = await api.post(
                      `inbound/pr-draft/assign-area/${inboundId}`,
                      {
                        areas: assignAreaId.find(
                          (inbound) => inbound.inbound_id === inboundId
                        )?.areas
                      }
                    )
                    if (res.data.success) {
                      Swal.close()
                      // override state value assign area id to empty array
                      setAssignAreaId((prevAssignAreaId) =>
                        prevAssignAreaId.filter(
                          (assignArea) => assignArea.inbound_id !== inboundId
                        )
                      )
                      loadData(id)
                      Common.showPopUpSuccessMessage('Success')
                    }
                  } catch (err) {
                    Swal.close()
                    const errMsg =
                      err?.response?.data?.errors?.message ||
                      'An error occurred'
                    Common.showPopUpErrorMessage(errMsg)
                  }
                }
              })
          } finally {
            setLoadingSendToErp(false)
          }
        } else {
          return false
        }
      })
  }

  const checkAssignArea = (inboundId) => {
    const lengthItemAssignAreaByInbound = assignAreaId.find((inbound) => {
      return inbound.inbound_id === inboundId
    })?.areas.length
    const lengthItemInbounds = detail?.inbounds.find((inbound) => {
      return inbound.id === inboundId
    })?.items.length

    return lengthItemInbounds === lengthItemAssignAreaByInbound
  }

  const handleDisableInputNoteItem = (data, inboundItemId) => {
    const areaInboundItemId = assignAreaId
      .find((assignArea) => assignArea.inbound_id === data?.id)
      ?.areas.find(
        (area) => area.item_staging_area_id === inboundItemId
      )?.area_id
    const getCodeArea = !areaInboundItemId
      ? null
      : areaData.find((area) => area.value === areaInboundItemId)?.code || ''
    if (
      (data?.status === 'waiting_om' || data?.status === 'request_pnp') &&
      (!data?.erp_code || (data?.has_karantina && !data?.erp_code_karantina)) &&
      (getCodeArea === 'KR' || getCodeArea === 'BDF_KR')
    ) {
      return false
    }
    return true
  }

  const handleUpdatePack = async (prId, stagingItemId) => {
    try {
      setLoadingSendToErp(true)
      const res = await api.put(
        `/inbound/pr-draft/${prId}/staging/${stagingItemId}`,
        {
          total_pack: dirtyPacks[stagingItemId]
        }
      )
      if (res.data.success) {
        Common.showPopUpSuccessMessage('Success updated qty')
        setDirtyPacks((prev) => {
          const next = { ...prev }
          delete next[stagingItemId]
          return next
        })
        loadData(id)
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoadingSendToErp(false)
    }
  }

  const handleInputNoteInbound = (inboundId, inboundIteemId, value) => {
    setDetail((detailPrev) => ({
      ...detailPrev,
      inbounds: detailPrev.inbounds.map((inbound) => {
        if (inbound.id === inboundId) {
          return {
            ...inbound,
            items: inbound.items.map((item) =>
              item.id === inboundIteemId
                ? {
                    ...item,
                    note: value
                  }
                : item
            )
          }
        }
        return inbound
      })
    }))
    setAssignAreaId((assignAreaPrev) =>
      assignAreaPrev.map((inbound) => {
        if (inbound.inbound_id === inboundId) {
          return {
            ...inbound,
            areas: inbound.areas.map((area) =>
              area.item_staging_area_id === inboundIteemId
                ? {
                    ...area,
                    note: value
                  }
                : area
            )
          }
        }
        return inbound
      })
    )
  }

  const handleUpdateItemCoa = (item) => {
    setModalUpdateItemCoa(true)
    setSelectedItemCoa({
      id: item.id,
      coa_pd: item.coa_md,
      coa_ed: item.coa_ed,
      label_ed: item.label_ed,
      label_pd: item.label_md,
      batch: item?.batch,
      batch_id: item?.batch_id,
      item: item?.item_name,
      coa_doc: item?.coa_doc,
      coa_status: item?.coa_status,
      coa_document_id: item?.coa_document_id,
      item_id: item?.item_id,
      total_pack: item?.total_pack,
      receiving_uom: item?.uom_pack,
      note: item?.remark
    })
  }

  const handleSubmitRetrySendErp = async () => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary-orange',
        cancelButton: 'btn btn-transparent',
        actions:
          'd-flex w-100 justify-content-end pt-4 ps-4 pe-4 separator-border-action-sweetalert'
      },
      buttonsStyling: false
    })
    swalWithBootstrapButtons
      .fire({
        title: 'Send to ERP?',
        text: 'This action can’t be repeated!',
        icon: 'warning',
        iconColor: '#828282',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Send!',
        cancelButtonText: 'Cancel',
        allowOutsideClick: false,
        reverseButtons: true,
        showCloseButton: true
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          try {
            const res = await api.post(`/inbound/pr-draft/${id}/retry-send`)
            const { status } = res
            if (status === 200) {
              loadData(id)
            }
          } catch (err) {
            Swal.close()
            const errMsg =
              err?.response?.data?.errors?.message || 'An error occurred'
            const swalWithBootstrapButtonError = Swal.mixin({
              customClass: {
                confirmButton: 'btn btn-primary-orange',
                cancelButton: 'btn btn-transparent',
                actions:
                  'd-flex w-100 justify-content-end pt-4 ps-4 pe-4 separator-border-action-sweetalert'
              },
              buttonsStyling: false
            })
            swalWithBootstrapButtonError
              .fire({
                html: `<p>Send to ERP <span class='text-danger fw-bold text-uppercase'>failed</span></p><br><p>Reason: ${errMsg}</p>`,
                icon: 'error',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Resend',
                allowOutsideClick: false,
                showCloseButton: true
              })
              .then(async (result) => {
                if (result.isConfirmed) {
                  try {
                    const res = await api.post(
                      `/inbound/pr-draft/${id}/retry-send`
                    )
                    const { status } = res
                    if (status === 200) {
                      loadData(id)
                    }
                  } catch (err) {
                    Swal.close()
                    const errMsg =
                      err?.response?.data?.errors?.message ||
                      'An error occurred'
                    Common.showPopUpErrorMessage(errMsg)
                  }
                }
              })
          }
        } else {
          return false
        }
      })
  }

  const showButtonRetrySendErpToWarehouse = () => {
    if (
      detail?.po_info?.pr_method === 'cross_dock' &&
      !detail?.po_info?.pr_code_erp
    ) {
      return true
    }
    if (detail?.po_info?.is_external) {
      const getDataAreaUtama =
        detail?.po_info?.items_coa?.filter((coa) => coa.area.code === 'UT')
          ?.length || 0
      const getDataAreaKarantina =
        detail?.po_info?.items_coa?.filter(
          (coa) => coa.area.code === 'KR' || coa.area_code === 'BDF_KR'
        )?.length || 0
      const getDataAreaReject =
        detail?.po_info?.items_coa?.filter((coa) => coa.area.code === 'RJ')
          ?.length || 0
      if (!detail?.po_info?.pr_code_erp && getDataAreaUtama > 0) return true
      if (!detail?.po_info?.pr_code_erp_karantina && getDataAreaKarantina > 0)
        return true
      if (!detail?.po_info?.pr_code_erp_reject && getDataAreaReject > 0)
        return true
    }
    return false
  }

  const handleDownloadDocumentCoa = async (batch_id) => {
    try {
      setDownloadDocumentCoa((prev) => ({
        ...prev,
        [batch_id]: true
      }))
      const res = await api.get(`/master/batch/${batch_id}/download-coa`, {
        responseType: 'arraybuffer'
      })
      const { status, data } = res
      if (status === 200) {
        const blob = new Blob([data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `download-coa-${batch_id}.pdf`)
        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      }
    } catch (error) {
      const err = error?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(err)
    } finally {
      setDownloadDocumentCoa((prev) => ({
        ...prev,
        [batch_id]: false
      }))
    }
  }

  const statusTextMapping = {
    unassigned: 'unassigned',
    waiting_rnr: 'waiting rnr',
    receiving_progress: 'receiving progress',
    rnr: 'receiving progress',
    waiting_om: 'waiting om',
    request_pnp: 'waiting om',
    waiting_pnp: 'waiting pnp',
    pnp: 'put away',
    put_away: 'put away',
    done: 'done',
    revised: 'waiting rnr'
  }

  const statusCoaMapping = {
    unchecked: 'unchecked',
    match: 'match',
    not_match: 'not match'
  }

  const handleDownloadFileAttachment = (attachment) => {
    window.open(attachment, '_blank')
  }

  const handleDownloadLabel = async (labelId) => {
    try {
      const payload = {
        inbound_staging_id: detail?.po_info?.is_external ? null : labelId,
        item_coa_id: detail?.po_info?.is_external ? labelId : null
      }
      const res = await api.post(`/inbound/pr-draft/${id}/label`, payload, {
        responseType: 'arraybuffer'
      })
      const { status, data } = res
      if (status === 200) {
        const blob = new Blob([data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `download-label.pdf`)
        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      }
    } catch (error) {
      const err = error?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(err)
    }
  }

  const handleDownloadGoodReceipt = async () => {
    try {
      setLoadingDownloadGoodReceipt(true)

      const res = await api.post(
        `/inbound/pr-draft/${detail?.po_info?.id}/good-receipt`,
        {},
        { responseType: 'arraybuffer' }
      )

      const { status, data } = res

      if (status === 200) {
        const blob = new Blob([data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
          'download',
          `download-goods-receipt-${detail?.po_info?.po_code}.pdf`
        )
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      }
    } catch (error) {
      const err = error?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(err)
    } finally {
      setLoadingDownloadGoodReceipt(false)
    }
  }

  const labelConditionText = (name) => {
    if (name === 'good') return 'Baik'
    if (name === 'coa_not_match') return 'Coa Not Match'
    if (name === 'damaged') return 'Rusak'
    return name
  }

  return (
    <>
      <Container className="mb-5">
        {isLoading && <Loading />}
        {!isLoading && (
          <>
            <Row>
              <Col md={9} className="mt-3">
                <Breadcrumb
                  label={detail?.po_info?.po_code}
                  link={
                    state?.source === 'inbound-history'
                      ? '/inbound/history'
                      : '/inbound/purchase-receipt'
                  }
                  back={
                    state?.source === 'inbound-history'
                      ? 'INBOUND HISTORY'
                      : 'PURCHASE RECEIPT'
                  }
                  type="BadgeStatusPrList"
                  status={detail?.po_info?.draft_status}
                  stateValue={state}
                />
              </Col>
              <Col md={3}>
                {detail?.po_info?.is_external ||
                detail?.po_info?.pr_method === 'cross_dock' ? (
                  <button
                    className="btn btn-primary-orange text-right float-end py-3 px-4"
                    onClick={() => handleDownloadGoodReceipt()}
                  >
                    <Download size={15} className="fa-flip-horizontal" />{' '}
                    {!loadingDownloadPackingList
                      ? 'Goods Receipt'
                      : 'Download...'}
                  </button>
                ) : null}
              </Col>
            </Row>
            <Row className="mt-3">
              <Formik
                initialValues={{
                  do: '',
                  pib_date: '',
                  expedition: '',
                  aju: '',
                  pic_number: '',
                  vehicle: '',
                  total_pack: ''
                }}
                enableReinitialize={true}
                validateOnChange={true}
                validationSchema={
                  detail?.po_info?.draft_status !== 'done'
                    ? PurchaseReceiptCreateImportSchema
                    : null
                }
                onSubmit={() => {
                  handleSubmit()
                }}
              >
                {({
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  values,
                  touched,
                  errors,
                  resetForm
                }) => {
                  return (
                    <Form onSubmit={handleSubmit}>
                      <Card style={cardStyle}>
                        <Row>
                          <StyledDetailField
                            label="#po"
                            value={detail?.po_info?.po_code}
                            col={3}
                          />
                          <StyledDetailField
                            label="po type"
                            value={detail?.po_info?.pr_type}
                            col={3}
                          />
                          <StyledDetailField
                            label="branch"
                            value={detail?.po_info?.branch}
                            col={3}
                          />
                          <StyledDetailField
                            label="supplier"
                            value={detail?.po_info?.supplier}
                            col={3}
                          />
                          <StyledDetailField
                            label="SERIES"
                            value={detail?.po_info?.series_number}
                            col={3}
                          />
                          <StyledDetailField
                            label="accepted warehouse"
                            value={detail?.po_info?.acc_warehouse_id}
                            col={3}
                          />
                          <StyledDetailField
                            label="method"
                            value={transformKey(
                              detail?.po_info?.pr_method || ''
                            )}
                            col={3}
                          />
                        </Row>
                      </Card>
                      {/* ARRIVAL */}
                      <Card style={cardStyle}>
                        <Row className="mb-3">
                          <Col
                            md={12}
                            className="d-flex justify-content-between align-items-center"
                          >
                            <h5
                              className="text-secondary mb-0"
                              style={{ fontSize: '1rem', fontWeight: 'bold' }}
                            >
                              ARRIVAL INFO
                            </h5>
                            {open ? (
                              <ChevronUp
                                style={{ cursor: 'pointer' }}
                                onClick={() => setOpen(!open)}
                                aria-expanded={open}
                                aria-controls="example-collapse-text"
                                size={20}
                              />
                            ) : (
                              <ChevronDown
                                style={{ cursor: 'pointer' }}
                                onClick={() => setOpen(!open)}
                                aria-expanded={open}
                                aria-controls="example-collapse-text"
                                size={20}
                              />
                            )}
                          </Col>
                        </Row>
                        <Collapse in={open}>
                          <div id="example-collapse-text">
                            <Row>
                              {detail?.po_info?.pr_type === 'local' && (
                                <>
                                  <StyledDetailField
                                    label="#do"
                                    value={detail?.arrival_info?.do}
                                    col={3}
                                  />
                                  <StyledDetailField
                                    label="expedition"
                                    value={detail?.arrival_info?.expedition}
                                    col={3}
                                  />
                                  <StyledDetailField
                                    label="pic name"
                                    value={detail?.arrival_info?.pic_name}
                                    col={3}
                                  />
                                  <StyledDetailField
                                    label="pic number"
                                    value={detail?.arrival_info?.pic_number}
                                    col={3}
                                  />
                                </>
                              )}
                              {detail?.po_info?.pr_type === 'import' && (
                                <>
                                  <StyledDetailField
                                    label="#do"
                                    value={detail?.arrival_info?.do}
                                    col={3}
                                  />
                                  <StyledDetailField
                                    label="expedition"
                                    value={detail?.arrival_info?.expedition}
                                    col={3}
                                  />
                                  <StyledDetailField
                                    label="pib date"
                                    value={
                                      detail?.arrival_info?.pib_date
                                        ? convertDateWithoutTime(
                                            detail?.arrival_info?.pib_date
                                          )
                                        : '-'
                                    }
                                    col={3}
                                  />
                                  <StyledDetailField
                                    label="#aju"
                                    value={detail?.arrival_info?.aju}
                                    col={3}
                                  />
                                  <StyledDetailField
                                    label="pic name"
                                    value={detail?.arrival_info?.pic_name}
                                    col={3}
                                  />
                                  <StyledDetailField
                                    label="pic number"
                                    value={detail?.arrival_info?.pic_number}
                                    col={3}
                                  />
                                </>
                              )}
                            </Row>
                          </div>
                        </Collapse>
                      </Card>
                      {/* VEHICLE */}
                      {detail?.po_info?.pr_method !== 'cross_dock' && (
                        <Card style={cardStyle}>
                          <Row className="mb-3">
                            <Col
                              md={12}
                              className="d-flex justify-content-between align-items-center"
                            >
                              <h5
                                className="text-secondary mb-0"
                                style={{ fontSize: '1rem', fontWeight: 'bold' }}
                              >
                                VEHICLE
                              </h5>
                              {openVehicle ? (
                                <ChevronUp
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => setOpenVehicle(!openVehicle)}
                                  aria-expanded={openVehicle}
                                  aria-controls="example-collapse-text1"
                                  size={20}
                                />
                              ) : (
                                <ChevronDown
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => setOpenVehicle(!openVehicle)}
                                  aria-expanded={openVehicle}
                                  aria-controls="example-collapse-text1"
                                  size={20}
                                />
                              )}
                            </Col>
                          </Row>
                          <Collapse in={openVehicle}>
                            <div id="example-collapse-text1">
                              <Row>
                                <StyledTextField
                                  label="plate no."
                                  name="vehicle"
                                  value={values.vehicle}
                                  handleChange={handleChange}
                                  handleBlur={handleBlur}
                                  touched={touched}
                                  errors={errors}
                                  placeholder="Input vehicle"
                                  col={10}
                                  bold
                                  required
                                  disabled={
                                    detail?.po_info?.draft_status === 'done'
                                      ? true
                                      : false
                                  }
                                />
                                <Col
                                  md={2}
                                  className="d-flex align-items-end mb-3"
                                >
                                  {detail?.po_info?.draft_status === 'done' ? (
                                    <Button
                                      type="button"
                                      className="btn btn-primary-blue w-100"
                                      onClick={() =>
                                        addVehicle(values.vehicle, resetForm)
                                      }
                                      disabled={true}
                                      style={{ height: '40px' }}
                                    >
                                      Add Vehicle
                                    </Button>
                                  ) : (
                                    <Button
                                      type="button"
                                      className="btn btn-primary-blue w-100"
                                      style={{
                                        height: '40px'
                                      }}
                                      onClick={() =>
                                        addVehicle(values.vehicle, resetForm)
                                      }
                                      disabled={!values.vehicle}
                                    >
                                      Add Vehicle
                                    </Button>
                                  )}
                                </Col>
                                <Col md={12} className="mt-3">
                                  {newDataVehicles.length > 0 && (
                                    <Table
                                      hover
                                      responsive
                                      className="mb-0"
                                      size="sm"
                                      style={{ fontSize: '12px' }}
                                    >
                                      <thead>
                                        <tr>
                                          <th
                                            style={tableHeaderStyle}
                                            className="p-2 align-middle"
                                          >
                                            No
                                          </th>
                                          <th
                                            style={{
                                              ...tableHeaderStyle,
                                              width: '30%'
                                            }}
                                            className="p-2"
                                          >
                                            Plate No
                                          </th>
                                          <th
                                            style={tableHeaderStyle}
                                            className="p-2 text-end align-middle"
                                          >
                                            SIM
                                          </th>
                                          <th
                                            style={tableHeaderStyle}
                                            className="p-2 text-end align-middle"
                                          >
                                            Validity
                                          </th>
                                          <th
                                            style={tableHeaderStyle}
                                            className="p-2 text-end align-middle"
                                          >
                                            Notes
                                          </th>
                                          <th
                                            style={tableHeaderStyle}
                                            className="p-2 text-end align-middle"
                                          >
                                            STNK
                                          </th>
                                          <th
                                            style={tableHeaderStyle}
                                            className="p-2 text-end align-middle"
                                          >
                                            Validity
                                          </th>
                                          <th
                                            style={{
                                              ...tableHeaderStyle,
                                              width: '20%'
                                            }}
                                            className="p-2 text-end align-middle"
                                          >
                                            Notes
                                          </th>
                                          <th
                                            style={tableHeaderStyle}
                                            className="p-2 text-end align-middle"
                                          >
                                            Action
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {newDataVehicles.map(
                                          (vehicle, index) => (
                                            <tr key={index}>
                                              <td className="p-2 align-middle">
                                                {index + 1}
                                              </td>
                                              <td className="p-2 align-middle">
                                                {vehicle.plate_no || '-'}
                                              </td>
                                              <td className="p-2 text-end align-middle text-primary">
                                                <a
                                                  href={
                                                    vehicle.sim_doc
                                                      ? vehicle.sim_doc
                                                      : '#'
                                                  }
                                                  target="_blank"
                                                  className="text-decoration-none"
                                                  rel="noreferrer"
                                                >
                                                  {vehicle.sim_doc
                                                    ? vehicle.sim_doc.name ||
                                                      vehicle.sim_doc
                                                        .split('/')
                                                        .pop()
                                                    : '-'}
                                                </a>
                                              </td>
                                              <td className="p-2 text-end align-middle">
                                                {vehicle.sim_validity &&
                                                vehicle.sim_validity !== ''
                                                  ? 'Valid'
                                                  : 'Invalid'}
                                              </td>
                                              <td
                                                className="p-2 text-end align-middle"
                                                style={{
                                                  wordBreak: 'break-word',
                                                  whiteSpace: 'normal',
                                                  minWidth: '100px',
                                                  maxWidth: '150px'
                                                }}
                                              >
                                                {vehicle.sim_notes || '-'}
                                              </td>
                                              <td className="p-2 text-end align-middle text-primary">
                                                <a
                                                  href={
                                                    vehicle.stnk_doc
                                                      ? vehicle.stnk_doc
                                                      : '#'
                                                  }
                                                  target="_blank"
                                                  className="text-decoration-none"
                                                  rel="noreferrer"
                                                >
                                                  {vehicle.stnk_doc
                                                    ? vehicle.stnk_doc.name ||
                                                      vehicle.stnk_doc
                                                        .split('/')
                                                        .pop()
                                                    : '-'}
                                                </a>
                                              </td>
                                              <td className="p-2 text-end align-middle">
                                                {vehicle.stnk_validity &&
                                                vehicle.stnk_validity !== ''
                                                  ? 'Valid'
                                                  : 'Invalid'}
                                              </td>
                                              <td
                                                className="p-2 text-end align-middle"
                                                style={{
                                                  wordBreak: 'break-word',
                                                  whiteSpace: 'normal',
                                                  minWidth: '100px',
                                                  maxWidth: '150px'
                                                }}
                                              >
                                                {vehicle.stnk_notes || '-'}
                                              </td>
                                              <td className="p-2 text-end align-middle">
                                                <div className="d-flex flex-row gap-2 justify-content-end">
                                                  <button
                                                    className="btn btn-secondary ml-2"
                                                    type="button"
                                                    onClick={() =>
                                                      handleUpdateVehicle(
                                                        vehicle
                                                      )
                                                    }
                                                    disabled={
                                                      detail?.po_info
                                                        ?.draft_status ===
                                                      'done'
                                                    }
                                                  >
                                                    <Edit size={16} />
                                                  </button>
                                                  <button
                                                    className="btn btn-danger ml-2"
                                                    type="button"
                                                    onClick={() =>
                                                      onDeleteItemVehicle(
                                                        vehicle.id
                                                      )
                                                    }
                                                    hidden={
                                                      !(
                                                        vehicle.status ===
                                                          'waiting_rnr' ||
                                                        vehicle.status ===
                                                          'unassigned'
                                                      )
                                                    }
                                                  >
                                                    <Trash2 size={16} />
                                                  </button>
                                                </div>
                                              </td>
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    </Table>
                                  )}
                                </Col>
                              </Row>
                            </div>
                          </Collapse>
                        </Card>
                      )}
                      {/* ITEM & COA */}
                      <Card style={cardStyle}>
                        <Row className="mb-3">
                          <Col
                            md={12}
                            className="d-flex justify-content-between align-items-center"
                          >
                            <h5
                              className="text-secondary mb-0"
                              style={{ fontSize: '1rem', fontWeight: 'bold' }}
                            >
                              <AlertCircle
                                className="text-danger me-2"
                                hidden={differentDate === false ? false : true}
                                size={20}
                              />
                              ITEM & COA
                            </h5>
                            {openItemCoa ? (
                              <ChevronUp
                                style={{ cursor: 'pointer' }}
                                onClick={() => setOpenItemCoa(!openItemCoa)}
                                aria-expanded={openItemCoa}
                                aria-controls="example-collapse-text2"
                                size={20}
                              />
                            ) : (
                              <ChevronDown
                                style={{ cursor: 'pointer' }}
                                onClick={() => setOpenItemCoa(!openItemCoa)}
                                aria-expanded={openItemCoa}
                                aria-controls="example-collapse-text2"
                                size={20}
                              />
                            )}
                          </Col>
                        </Row>
                        <Collapse in={openItemCoa}>
                          <div id="example-collapse-text2">
                            <div className="d-flex justify-content-between align-items-center mb-3 mt-3">
                              <h6 className="mb-0 text-secondary">
                                LIST ITEMS IN DRAFT
                              </h6>
                              <Button
                                className="btn btn-primary-blue"
                                onClick={() => setShowModalAddItem(true)}
                                disabled={isDraftDisabled}
                              >
                                <Plus className="me-2" size={16} />
                                Add Item
                              </Button>
                            </div>

                            <ModalAddItemPr
                              show={showModalAddItem}
                              onHide={() => setShowModalAddItem(false)}
                              prId={id}
                              items={items}
                              loadData={loadData}
                              detail={detail}
                            />
                            <Row className="">
                              <Col md={12} className="mt-3 overflow-x-auto">
                                <Table
                                  hover
                                  responsive
                                  className="mb-0"
                                  size="sm"
                                  style={{ fontSize: '12px' }}
                                >
                                  <thead>
                                    <tr>
                                      <th
                                        style={tableHeaderStyle}
                                        className="p-2 align-middle"
                                      >
                                        No
                                      </th>
                                      <th
                                        style={{
                                          ...tableHeaderStyle,
                                          width: '20%'
                                        }}
                                        className="p-2 align-middle"
                                      >
                                        Item Code - Name
                                      </th>
                                      {!detail?.po_info?.is_external &&
                                        detail?.po_info?.pr_method ===
                                          'to_warehouse' && (
                                          <th
                                            style={tableHeaderStyle}
                                            className="p-2 align-middle"
                                          >
                                            Status COA
                                          </th>
                                        )}

                                      <th
                                        style={tableHeaderStyle}
                                        className="p-2 text-end align-middle"
                                      >
                                        Batch
                                      </th>
                                      <th
                                        style={tableHeaderStyle}
                                        className="p-2 text-end align-middle"
                                      >
                                        Receiving
                                      </th>
                                      <th
                                        style={tableHeaderStyle}
                                        className="p-2 text-end align-middle"
                                      >
                                        Base UOM Qty
                                      </th>
                                      <th
                                        style={tableHeaderStyle}
                                        className="p-2 text-end align-middle"
                                      >
                                        COA Document
                                      </th>
                                      <th
                                        style={tableHeaderStyle}
                                        className="p-2 text-end align-middle"
                                      >
                                        COA MD
                                      </th>
                                      <th
                                        style={tableHeaderStyle}
                                        className="p-2 text-end align-middle"
                                      >
                                        COA ED
                                      </th>
                                      <th
                                        style={tableHeaderStyle}
                                        className="p-2 text-end align-middle"
                                      >
                                        Label MD
                                      </th>
                                      <th
                                        style={tableHeaderStyle}
                                        className="p-2 text-end align-middle"
                                      >
                                        Label ED
                                      </th>

                                      {detail?.po_info?.is_external && (
                                        <>
                                          <th
                                            style={tableHeaderStyle}
                                            className="p-2 text-end align-middle"
                                          >
                                            Destination Area
                                          </th>
                                          <th
                                            style={tableHeaderStyle}
                                            className="p-2 text-end align-middle"
                                          >
                                            Problem
                                          </th>
                                          <th
                                            style={tableHeaderStyle}
                                            className="p-2 text-end align-middle"
                                          >
                                            Remark
                                          </th>
                                        </>
                                      )}
                                      {detail?.po_info?.pr_method ===
                                        'to_warehouse' && (
                                        <th
                                          style={tableHeaderStyle}
                                          className="p-2 text-center align-middle"
                                        >
                                          {detail?.po_info?.is_external
                                            ? 'Label'
                                            : 'Action'}
                                        </th>
                                      )}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {detail?.items_coa?.map((item, i) => {
                                      return (
                                        <>
                                          <tr key={i}>
                                            <td className="p-2 align-middle">
                                              {i + 1}
                                            </td>
                                            <td className="p-2 align-middle">
                                              {item?.item_code}
                                              {' - '}
                                              {item?.item_name}
                                            </td>
                                            {!detail?.po_info?.is_external &&
                                              detail?.po_info?.pr_method ===
                                                'to_warehouse' && (
                                                <td className="p-2 align-middle">
                                                  <BadgeStatusCOA
                                                    text={
                                                      statusCoaMapping[
                                                        item?.coa_status
                                                      ] || 'unchecked'
                                                    }
                                                  />
                                                </td>
                                              )}
                                            <td className="p-2 text-end align-middle">
                                              <div className="d-flex flex-row gap-2 justify-content-end">
                                                {item?.is_new_batch && (
                                                  <div
                                                    style={{
                                                      marginTop: '-.5rem'
                                                    }}
                                                  >
                                                    <Badge pill bg="success">
                                                      New
                                                    </Badge>
                                                  </div>
                                                )}
                                                {item?.batch
                                                  ? item?.batch
                                                  : '-'}
                                              </div>
                                            </td>
                                            <td className="p-2 text-end align-middle">
                                              {item?.total_pack !== null
                                                ? `${item?.total_pack} ${item?.uom_pack}`
                                                : '-'}
                                            </td>
                                            <td className="p-2 text-end align-middle">
                                              {item?.total_qty !== null
                                                ? `${item?.total_qty} ${item?.uom_qty}`
                                                : '-'}
                                            </td>
                                            <td className="p-2 text-end align-middle text-primary">
                                              <button
                                                disabled={
                                                  downloadDocumentCoa?.[
                                                    item?.batch_id
                                                  ]
                                                }
                                                onClick={(e) => {
                                                  e.preventDefault()
                                                  handleDownloadDocumentCoa(
                                                    item?.batch_id
                                                  )
                                                }}
                                                className={`border-0 bg-transparent ${
                                                  downloadDocumentCoa?.[
                                                    item?.batch_id
                                                  ]
                                                    ? 'text-black cursor-not-allowed'
                                                    : 'text-primary'
                                                } text-decoration-underline`}
                                              >
                                                {downloadDocumentCoa?.[
                                                  item?.batch_id
                                                ]
                                                  ? 'Downloading...'
                                                  : 'Download'}
                                              </button>
                                            </td>
                                            <td className="p-2 text-end align-middle">
                                              {item?.coa_md
                                                ? convertDateWithoutTime(
                                                    item?.coa_md
                                                  )
                                                : '-'}
                                            </td>
                                            <td className="p-2 text-end align-middle">
                                              {item?.coa_ed
                                                ? convertDateWithoutTime(
                                                    item?.coa_ed
                                                  )
                                                : '-'}
                                            </td>
                                            <td className="p-2 text-end align-middle">
                                              {item?.label_md
                                                ? convertDateWithoutTime(
                                                    item?.label_md
                                                  )
                                                : '-'}
                                            </td>
                                            <td className="p-2 text-end align-middle">
                                              {item?.label_ed
                                                ? convertDateWithoutTime(
                                                    item?.label_ed
                                                  )
                                                : '-'}
                                            </td>

                                            {detail?.po_info?.is_external && (
                                              <>
                                                <td className="p-2 text-end align-middle">
                                                  {item?.area?.name ?? '-'}
                                                </td>
                                                <td className="p-2 text-end align-middle">
                                                  {item?.problem
                                                    ? transformKey(
                                                        item?.problem
                                                      )
                                                    : '-'}
                                                </td>
                                                <td className="p-2 text-end align-middle">
                                                  {item?.remark ?? '-'}
                                                </td>
                                              </>
                                            )}
                                            {!detail?.po_info?.is_external &&
                                              detail?.po_info?.pr_method ===
                                                'to_warehouse' && (
                                                <td className="p-2 align-middle text-center">
                                                  <div className="d-flex justify-content-center gap-2">
                                                    <button
                                                      className="btn btn-secondary"
                                                      type="button"
                                                      onClick={() => {
                                                        handleUpdateItemCoa(
                                                          item
                                                        )
                                                      }}
                                                      disabled={isDraftDisabled}
                                                    >
                                                      <Edit size={16} />
                                                    </button>
                                                    <button
                                                      className="btn btn-danger"
                                                      type="button"
                                                      onClick={() => {
                                                        onDeleteItemCoa(item)
                                                      }}
                                                      disabled={isDraftDisabled}
                                                    >
                                                      <Trash2 size={16} />
                                                    </button>
                                                  </div>
                                                </td>
                                              )}
                                            {detail?.po_info?.is_external &&
                                              detail?.po_info?.pr_method ===
                                                'to_warehouse' && (
                                                <td className="p-2 align-middle text-center">
                                                  <Button
                                                    variant="warning"
                                                    style={{
                                                      cursor: 'pointer'
                                                    }}
                                                    onClick={() =>
                                                      handleDownloadLabel(
                                                        item?.id
                                                      )
                                                    }
                                                  >
                                                    <Download
                                                      className="text-white"
                                                      size={16}
                                                    />
                                                  </Button>
                                                </td>
                                              )}
                                          </tr>
                                        </>
                                      )
                                    })}
                                  </tbody>
                                </Table>
                              </Col>
                              <Col
                                md={12}
                                hidden={
                                  detail?.items_coa?.filter(
                                    (coa) => coa.coa_status === 'not_match'
                                  ).length > 0
                                    ? false
                                    : true
                                }
                                style={{
                                  marginTop: '-10px',
                                  marginBottom: '10px'
                                }}
                              >
                                <small className="text-danger fw-bold">
                                  Different date / Not complete !
                                </small>
                              </Col>
                            </Row>
                          </div>
                        </Collapse>
                      </Card>
                      {/* INBOUND */}
                      {detail?.inbounds?.map((data, i) => {
                        return (
                          <Card key={i} style={cardStyle}>
                            <Card.Body className="p-0">
                              <Row className="mb-3">
                                <Col xs={12} md={6} lg={6}>
                                  <Row>
                                    <Col md={12}>
                                      <h5
                                        className="fw-bold"
                                        style={{ fontSize: '1rem' }}
                                      >
                                        <RotateCcw
                                          style={{
                                            cursor: 'pointer',
                                            marginRight: '5px'
                                          }}
                                          size={14}
                                          onClick={() => handleTimline(data)}
                                        />
                                        {data.ticket_id}
                                        {!data?.erp_code && (
                                          <sup
                                            style={{
                                              fontSize: '12px',
                                              marginLeft: '5px',
                                              marginTop: '-5px'
                                            }}
                                          >
                                            <BadgeStatusPrLists
                                              text={
                                                statusTextMapping[
                                                  data.status
                                                ] || 'done'
                                              }
                                            />
                                          </sup>
                                        )}
                                        {data?.erp_code && (
                                          <span className="text-warning fw-bold ms-2">
                                            - {data?.erp_code}
                                          </span>
                                        )}
                                        {data?.erp_code_karantina && (
                                          <span className="text-warning fw-bold ms-2">
                                            - {data?.erp_code_karantina}
                                          </span>
                                        )}
                                      </h5>
                                    </Col>
                                    <Col xs={6} md={6} lg={6} className="mt-1">
                                      STAGING AREA{' - '}
                                      {data.stagings
                                        .map((data) => data.name)
                                        .join(', ')}
                                    </Col>
                                  </Row>
                                </Col>
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={6}
                                  className="fw-bold text-start text-md-end text-lg-end mt-3 mt-md-0"
                                  style={{ fontSize: '12px' }}
                                >
                                  {data.vehicle.plate_no} -{' '}
                                  {data.status === 'done'
                                    ? 'DONE'
                                    : statusTextMapping[
                                        data.status
                                      ]?.toUpperCase()}
                                </Col>
                              </Row>

                              {data?.items.length > 0 && (
                                <Table
                                  hover
                                  responsive
                                  className="mb-0"
                                  size="sm"
                                  style={{ fontSize: '12px' }}
                                >
                                  <thead>
                                    <tr>
                                      <th
                                        style={tableHeaderStyle}
                                        className="p-2 align-middle"
                                      >
                                        Palet/Keranjang
                                      </th>
                                      <th
                                        style={{
                                          ...tableHeaderStyle,
                                          width: '20%'
                                        }}
                                        className="p-2 align-middle"
                                      >
                                        Item Code - Name
                                      </th>
                                      <th
                                        style={tableHeaderStyle}
                                        className="p-2 text-end align-middle"
                                      >
                                        Batch
                                      </th>
                                      <th
                                        style={tableHeaderStyle}
                                        className="p-2 text-end align-middle"
                                      >
                                        Pack
                                      </th>
                                      <th
                                        style={tableHeaderStyle}
                                        className="p-2 text-end align-middle"
                                      >
                                        Condition
                                      </th>
                                      <th
                                        style={tableHeaderStyle}
                                        className="p-2 text-end align-middle"
                                      >
                                        Location
                                      </th>
                                      <th
                                        style={tableHeaderStyle}
                                        className="p-2 align-middle"
                                      >
                                        Destination Area
                                      </th>
                                      <th
                                        style={tableHeaderStyle}
                                        className="p-2 align-middle"
                                      >
                                        Note
                                      </th>
                                      <th
                                        style={tableHeaderStyle}
                                        className="p-2 align-middle"
                                      >
                                        Label
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {data?.items?.map((item, i) => (
                                      <tr key={i}>
                                        <td
                                          className="p-2 align-middle"
                                          style={{
                                            backgroundColor: item.from_mobile
                                              ? '#FFCCCC'
                                              : 'white'
                                          }}
                                        >
                                          {item.palet_id
                                            ? '#' + item.palet_id
                                            : '-'}
                                        </td>
                                        <td
                                          className="p-2 align-middle"
                                          style={{
                                            backgroundColor: item.from_mobile
                                              ? '#FFCCCC'
                                              : 'white'
                                          }}
                                        >
                                          {item.item_code} - {item.item_name}
                                        </td>
                                        <td
                                          className="p-2 text-end align-middle"
                                          style={{
                                            backgroundColor: item.from_mobile
                                              ? '#FFCCCC'
                                              : 'white'
                                          }}
                                        >
                                          {item.batch}
                                        </td>
                                        <td
                                          className="p-2 text-end align-middle"
                                          style={{
                                            backgroundColor: item.from_mobile
                                              ? '#FFCCCC'
                                              : 'white'
                                          }}
                                        >
                                          {(data?.status === 'waiting_om' ||
                                            data?.status === 'request_pnp') &&
                                          (!data?.erp_code ||
                                            (data?.has_karantina &&
                                              !data?.erp_code_karantina)) ? (
                                            <div className="d-flex align-items-center justify-content-end gap-2">
                                              <Form.Control
                                                type="number"
                                                value={
                                                  dirtyPacks[item.id] !==
                                                  undefined
                                                    ? dirtyPacks[item.id]
                                                    : item.total_pack
                                                }
                                                onChange={(e) =>
                                                  setDirtyPacks({
                                                    ...dirtyPacks,
                                                    [item.id]: e.target.value
                                                  })
                                                }
                                                style={{
                                                  width: '80px',
                                                  height: '30px',
                                                  fontSize: '12px'
                                                }}
                                              />
                                              {dirtyPacks[item.id] !==
                                                undefined &&
                                                dirtyPacks[item.id] !==
                                                  item.total_pack && (
                                                  <div className="d-flex flex-column gap-1">
                                                    <Check
                                                      className="text-success cursor-pointer"
                                                      size={16}
                                                      onClick={() =>
                                                        handleUpdatePack(
                                                          detail?.po_info?.id,
                                                          item.id
                                                        )
                                                      }
                                                    />
                                                    <X
                                                      className="text-danger cursor-pointer"
                                                      size={16}
                                                      onClick={() => {
                                                        setDirtyPacks(
                                                          (prev) => {
                                                            const next = {
                                                              ...prev
                                                            }
                                                            delete next[item.id]
                                                            return next
                                                          }
                                                        )
                                                      }}
                                                    />
                                                  </div>
                                                )}
                                            </div>
                                          ) : (
                                            `${item.total_pack} ${item.uom_receiving}`
                                          )}
                                        </td>
                                        <td
                                          className="p-2 text-end align-middle fw-bold"
                                          style={{
                                            backgroundColor: item.from_mobile
                                              ? '#FFCCCC'
                                              : 'white'
                                          }}
                                        >
                                          {labelConditionText(item.condition)}
                                        </td>
                                        <td
                                          className="p-2 text-end align-middle"
                                          style={{
                                            backgroundColor: item.from_mobile
                                              ? '#FFCCCC'
                                              : 'white'
                                          }}
                                        >
                                          {item.current_location || '-'}
                                        </td>
                                        <td
                                          className="p-2 align-middle"
                                          style={{
                                            backgroundColor: item.from_mobile
                                              ? '#FFCCCC'
                                              : 'white'
                                          }}
                                        >
                                          {(!data?.erp_code ||
                                            (data?.has_karantina &&
                                              !data?.erp_code_karantina)) &&
                                            (data?.status === 'waiting_om' ||
                                              data?.status ===
                                                'request_pnp') && (
                                              <Select
                                                menuPortalTarget={document.body}
                                                isSearchable={true}
                                                isLoading={loadingArea}
                                                loadingMessage={() =>
                                                  'Loading...'
                                                }
                                                options={areaData}
                                                defaultOptions
                                                placeholder="Select Assign Area"
                                                styles={customStyles}
                                                key={item?.id}
                                                autoLoad={false}
                                                onFocus={() =>
                                                  setConditionItemInbound(
                                                    (prev) => ({
                                                      ...prev,
                                                      condition: item?.condition
                                                    })
                                                  )
                                                }
                                                onInputChange={(e) => {
                                                  setConditionItemInbound({
                                                    inputValue: e,
                                                    condition: item?.condition
                                                  })
                                                }}
                                                onChange={(e) =>
                                                  handleSelectAreaItemInbound(
                                                    data?.id,
                                                    item?.id,
                                                    e
                                                  )
                                                }
                                              />
                                            )}
                                          {(data?.status === 'done' ||
                                            data?.erp_code ||
                                            data?.erp_code_karantina) && (
                                            <p className="p-2 text-end d-flex h-100 justify-content-end mt-3">
                                              {item?.area ? (
                                                <span>{item?.area}</span>
                                              ) : (
                                                <span className="text-danger text-uppercase fw-bold">
                                                  tolak
                                                </span>
                                              )}
                                            </p>
                                          )}
                                        </td>
                                        <td
                                          className="p-2 align-middle"
                                          style={{
                                            backgroundColor: item.from_mobile
                                              ? '#FFCCCC'
                                              : 'white'
                                          }}
                                        >
                                          <Form.Control
                                            type="text"
                                            placeholder="Ketik Keterangan"
                                            value={item?.note || ''}
                                            onChange={(e) =>
                                              handleInputNoteInbound(
                                                data?.id,
                                                item?.id,
                                                e.target.value || ''
                                              )
                                            }
                                            disabled={handleDisableInputNoteItem(
                                              data,
                                              item?.id
                                            )}
                                          />
                                        </td>
                                        <td className="p-2 align-middle">
                                          <Button
                                            variant="warning"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() =>
                                              handleDownloadLabel(item?.id)
                                            }
                                            disabled={
                                              !['put_away', 'done'].includes(
                                                data?.status
                                              )
                                            }
                                          >
                                            <Download
                                              className="text-white"
                                              size={16}
                                            />
                                          </Button>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </Table>
                              )}

                              {(data?.status === 'waiting_om' ||
                                data?.status === 'request_pnp') &&
                                (!data?.erp_code ||
                                  (data?.has_karantina &&
                                    !data?.erp_code_karantina)) && (
                                  <Row className="mt-3 p-3">
                                    {data?.erp?.erp_status === false &&
                                      data?.erp?.err_notes && (
                                        <Col key={i} md={7}>
                                          <Row>
                                            <Col md={12}>
                                              <p>
                                                {' '}
                                                {data?.erp?.description}, <br />
                                                status:{' '}
                                                <span
                                                  style={{
                                                    color:
                                                      data?.erp?.erp_status ===
                                                      true
                                                        ? 'green'
                                                        : '#C12727'
                                                  }}
                                                  className="ms-2 fw-bold text-uppercase"
                                                >
                                                  {data?.erp?.erp_status ===
                                                  true
                                                    ? 'Success'
                                                    : 'Failed'}
                                                </span>
                                              </p>
                                            </Col>
                                            <Col md={12}>
                                              <span>Failed Reason: </span>
                                              <div
                                                dangerouslySetInnerHTML={{
                                                  __html: data?.erp?.err_notes
                                                }}
                                              ></div>
                                            </Col>
                                          </Row>
                                        </Col>
                                      )}
                                    <Col
                                      key={i}
                                      md={
                                        data?.erp?.erp_status === false &&
                                        data?.erp?.err_notes
                                          ? 5
                                          : 12
                                      }
                                      className="d-flex flex-row justify-content-end mb-3"
                                    >
                                      <small className="text-danger me-4 mt-1 fs-6">
                                        Ensure that all destination areas match
                                        the items
                                      </small>

                                      <div>
                                        <Button
                                          className={`btn ${
                                            loadingSendToErp
                                              ? 'btn-secondary opacity-50'
                                              : 'btn-warning'
                                          } text-white`}
                                          onClick={() =>
                                            handleSubmitAndSendErp(data?.id)
                                          }
                                          style={{ fontSize: '11.8px' }}
                                          disabled={loadingSendToErp}
                                        >
                                          {!loadingSendToErp
                                            ? 'Submit & Send to ERP'
                                            : 'Submitting...'}
                                        </Button>
                                      </div>
                                    </Col>
                                  </Row>
                                )}
                            </Card.Body>
                          </Card>
                        )
                      })}
                      {/* ITEM RECEIPT DETAILS */}
                      <TableItemReceiptDetails detail={detail} />
                      {/* send to erp button when condition erp code null */}
                      {showButtonRetrySendErpToWarehouse() && (
                        <div
                          className="d-flex justify-content-end w-100 mb-2"
                          style={{ marginTop: '-1.5rem' }}
                        >
                          <Button
                            className="btn btn-warning text-white cursor-pointer"
                            onClick={() => handleSubmitRetrySendErp()}
                            style={{ fontSize: '11.8px' }}
                            role="button"
                          >
                            Send to ERP
                          </Button>
                        </div>
                      )}
                      {/* ATTACHMENT */}
                      {(detail?.po_info?.is_external ||
                        detail?.po_info?.pr_method === 'cross_dock') &&
                        detail?.attachments?.length > 0 && (
                          <Card style={cardStyle}>
                            <Card.Body className="p-0">
                              <Row>
                                <Col md={12} className="mb-3">
                                  <h5
                                    className="text-secondary text-uppercase"
                                    style={{
                                      fontSize: '0.9rem',
                                      fontWeight: 'bold'
                                    }}
                                  >
                                    attachment{' '}
                                    <sup style={{ color: 'red' }}>*</sup>
                                  </h5>
                                </Col>
                              </Row>

                              <Row className="mt-1">
                                <Col md={5}>
                                  <div className="d-flex flex-column gap-3">
                                    {detail?.attachments?.map(
                                      (attachment, index) => (
                                        <div
                                          className="d-flex justify-content-between px-3 py-3 rounded"
                                          style={{
                                            border: '1px solid #ced4da',
                                            backgroundColor: '#f8f9fa'
                                          }}
                                          key={attachment.id}
                                        >
                                          <span className="fs-6 mt-2 ms-2">
                                            {attachment.attachment
                                              ?.split('/')
                                              .pop() || ''}
                                          </span>

                                          <button
                                            type="button"
                                            className="btn btn-secondary me-3"
                                            onClick={() =>
                                              handleDownloadFileAttachment(
                                                attachment.attachment
                                              )
                                            }
                                          >
                                            <Download size={16} />
                                          </button>
                                        </div>
                                      )
                                    )}
                                  </div>
                                </Col>
                              </Row>
                            </Card.Body>
                          </Card>
                        )}
                      {/* CREATED AT UPDATED AT */}
                      <div className="d-flex flex-column gap-3">
                        {detail?.po_info?.is_external ||
                        detail?.po_info?.pr_method === 'cross_dock' ? (
                          <Card style={cardStyle}>
                            <Card.Body className="p-0">
                              <Row>
                                <StyledDetailField
                                  label="#erp doc. no - Gudang Utama"
                                  value={
                                    !detail?.po_info?.pr_code_erp
                                      ? '-'
                                      : detail?.po_info?.pr_code_erp
                                  }
                                  col={4}
                                />
                                <StyledDetailField
                                  label="#erp doc. no - gudang karantina"
                                  value={
                                    !detail?.po_info?.pr_code_erp_karantina
                                      ? '-'
                                      : detail?.po_info?.pr_code_erp_karantina
                                  }
                                  col={4}
                                />
                                <StyledDetailField
                                  label="#erp doc. no - gudang reject"
                                  value={
                                    !detail?.po_info?.pr_code_erp_reject
                                      ? '-'
                                      : detail?.po_info?.pr_code_erp_reject
                                  }
                                  col={4}
                                />
                              </Row>
                            </Card.Body>
                          </Card>
                        ) : null}
                        <Card style={cardStyle}>
                          <Card.Body className="p-0">
                            <Row>
                              <StyledDetailField
                                label="created by"
                                value={
                                  !detail?.po_info?.createdby
                                    ? '-'
                                    : detail?.po_info?.createdby
                                }
                                col={3}
                              />
                              <StyledDetailField
                                label="created at"
                                value={
                                  !detail?.po_info?.createdAt
                                    ? '-'
                                    : convertDateWithTime(
                                        detail?.po_info?.createdAt
                                      )
                                }
                                col={3}
                              />
                              <StyledDetailField
                                label="last updated by"
                                value={
                                  !detail?.po_info?.updatedby
                                    ? '-'
                                    : detail?.po_info?.updatedby
                                }
                                col={3}
                              />
                              <StyledDetailField
                                label="last updated at"
                                value={
                                  !detail?.po_info?.updatedAt
                                    ? '-'
                                    : convertDateWithTime(
                                        detail?.po_info?.updatedAt
                                      )
                                }
                                col={3}
                              />
                            </Row>
                          </Card.Body>
                        </Card>
                      </div>
                    </Form>
                  )
                }}
              </Formik>
            </Row>
          </>
        )}
      </Container>

      <ModalUpdateVehiclePrDraft
        show={modalUpdateShow}
        onHide={() => setModalUpdateShow(false)}
        selectedVehicle={selectedVehicle}
        refreshdata={() => loadData(id)}
      />

      <ModalPrDetailTimeline
        show={modalTimeline}
        onHide={() => setModalTimeline(false)}
        detailinbounds={detailInbounds}
        datahistory={dataHistory}
        refreshdata={() => loadData(id)}
        loadingPrTimeline={loadingPrTimeline}
      />

      <ModalUpdateItemCoaPrDraftDetail
        show={modalUpdateItemCoa}
        onHide={() => setModalUpdateItemCoa(false)}
        selecteditemcoa={selectedItemCoa}
        pr_id={id}
        refreshdata={() => loadData(id)}
      />
    </>
  )
}

export default PurchaseReceiptDetail
